import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IGatewayResponse } from '@/Module/Core/Model/ApiModel';
import type { ILessonVideoLogs } from '@/Module/Lesson/Model/ApiModel';
import lessonService from '@/Module/Lesson/Service/LessonService';

export const sendLessonVideoLogsAction = createAsyncThunk<IGatewayResponse, ILessonVideoLogs>(
  'lesson/sendLessonVideoLogs',
  (req, { signal }) => {
    return lessonService
      .sendLessonVideoLogs(
        req,
        {
          disabledAutoError: true,
        },
        signal,
      )
      .then(({ data: { data } }) => {
        return data;
      });
  },
);
